import React from 'react'
import './Hero.css';
import { useNavigate } from "react-router-dom";


function Hero() {
    const navigate = useNavigate();
    const heroContents = [
        {
            id: 1,
            position: 1,
            title: 'Software Development Services',
            description: 'We deliver custom software, web, and mobile applications with consulting tailored to your business needs.'
        },
        {
            id: 2,
            position: 2,
            title: 'SaaS Solutions',
            description: 'Our SaaS platforms offer scalable, secure solutions with features that streamline operations and boost productivity.'
        },
        {
            id: 3,
            position: 3,
            title: 'Social Media Management',
            description: 'We manage social media by creating content, handling accounts, and analyzing performance to drive growth.'
        }
    ];
  return (
    <div className='hero' id='home'>
        <div className="mountain-waves">
            <svg viewBox="0 0 1440 500" preserveAspectRatio="none">
                
                <defs>
                    <linearGradient id="waveGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="0%" stopColor="#00f0ff" stopOpacity="0.2" />
                        <stop offset="50%" stopColor="#00ff9d" stopOpacity="0.6" />
                        <stop offset="100%" stopColor="#00f0ff" stopOpacity="0.2" />
                    </linearGradient>
                </defs>

                <path d="M0,300 C300,200 500,400 800,300 C1100,200 1300,350 1440,300" />
                <path d="M0,340 C300,240 500,440 800,340 C1100,240 1300,390 1440,340" />
                <path d="M0,380 C300,280 500,480 800,380 C1100,280 1300,430 1440,380" />

            </svg>
        </div>
        <div className='hero-content'>
            <h1>
                Powering Ideas Into Scalable Digital Solutions
            </h1>
            <p>
                From ready-to-use SaaS platforms to fully customized software, 
                RastegHub is your partner in building, strengthening and maintaining impactful digital solutions.
            </p>
            <div className='hero-btns'>
                <button 
                    className='hero-btn'
                    onClick={() => navigate('/quote')}              
                >
                    Get Started
                </button>
                <button 
                    className='hero-btn get'
                    onClick={() => navigate('/quote')}              
                >
                    Get Quote
                </button>
            </div>
            <div className='hero-conts'>
                <div className='hero-cont'>
                    {heroContents.map(content => (
                        <div key={content.id} className='hero-cont-item'>
                            <div className='hero-cont-pos'>{content.position}</div>
                            <div className='hero-cont-desc'>
                                <h3>{content.title}</h3>
                                <p>{content.description}</p>
                            </div>
                        </div>
                    ))}
                    
                    <div></div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Hero